import { FC, ReactElement, useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'
import register from '../../assets/register.svg'
import Footer from '../../components/footer'
import Frame from '../../components/frame'
import { Col, Row } from '../../components/grid'
import H1 from '../../components/h1'
import { MD } from '../../utils/screenSizes'
import Navigation from '../navigation'
import { Container } from '../register/style'

type LoginSkeletonProps = {
  title?: string
}

const LoginSkeleton: FC<LoginSkeletonProps> = ({ title = 'Acessar sua conta', children }): ReactElement => {
  const isTablet = useMediaQuery({ query: `(max-width: ${MD})` })

  useEffect(() => {
    document.body.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }, [])

  return (
    <>
      <Navigation variant='secondary' />
      <Frame style={{ marginTop: 70, marginBottom: 70 }}>
        <Col>
          <Row>
            <Container>
              <p>{title}</p>
              <H1>Preencha com seus dados de acesso.</H1>
              <img className='image' alt='registro' src={register} />
            </Container>
          </Row>
          <Row>
            <Container style={isTablet ? {} : { marginLeft: 45 }}>
              {children}
            </Container>
          </Row>
        </Col>
      </Frame>
      <Footer />
    </>
  )
}

export default LoginSkeleton
